export default "__VITE_ASSET__BD4LmETx__"